export default "__VITE_ASSET__DXSl9CZj__"